import CsSkeletonLoading from "./csSkeletonLoading";
export default CsSkeletonLoading;